import React, { useContext } from "react";
import commonContext from "../../../context/common";

function SanctionDetailsOfBorrower() {
    const { lead, utils } = useContext(commonContext);
    return (
        <>
            <div className="relative w-full">
                <div className="relative w-full md:w-1/2 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Full Name
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        {lead.pdApplicantFirstName} {lead.pdApplicantMiddleName}{" "}
                        {lead.pdApplicantLastName}
                    </p>
                </div>
            </div>
            <div className="relative w-full">
                <div className="relative w-full md:w-1/2 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Residential Address
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        {lead.pdPresentAddress1} {lead.pdPresentAddress2}{" "}
                        {lead.pdPresentAddress3} {lead.pdPresentAddress4}
                    </p>
                </div>
            </div>
            <div className="flex flex-wrap w-full relative border-b border-gray-300 mb-3 md:mb-6">
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Email ID
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        {lead.email}
                    </p>
                </div>
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Phone number
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        {lead.mobile}
                    </p>
                </div>
            </div>

            <div className="flex flex-wrap w-full relative">
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Loan Amount
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        {utils.currencyFormat(lead.totalAmount)}
                    </p>
                </div>
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Installment Frequency
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        Monthly
                    </p>
                </div>
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Tenure in Months (No. of EMIs)
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        {utils.currencyFormat(lead.liTenure)}
                    </p>
                </div>
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        No. of Adv. EMI
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        0
                    </p>
                </div>
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Adv. EMI Amount (Rs.)
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        0
                    </p>
                </div>
            </div>

            <div className="flex flex-wrap w-full relative">
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Processing Fees is Rs. (Non Refundable)
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        {utils.currencyFormat(lead.processingFees)}
                    </p>
                </div>
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        GST on Processing Fee (As per applicable law)
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        As per applicable law
                    </p>
                </div>
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Rate of Interest (Fixed Interest Rate)
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        3% p.a or as may be prescribed by the Bank
                    </p>
                </div>
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Rests at which interest is payable
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        {lead.interestRate}
                    </p>
                </div>
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Pre-EMI Interest
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        0
                    </p>
                </div>
                <div className="relative w-full md:w-1/2 lg:w-4/12 mb-3 md:mb-6">
                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                        Purpose
                    </p>
                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                        Personal
                    </p>
                </div>
            </div>
        </>
    );
}

export default SanctionDetailsOfBorrower;
